const getters = {
  isMobile: (state) => state.app.isMobile,
  lang: (state) => state.app.lang,
  theme: (state) => state.app.theme,
  color: (state) => state.app.color,
  addRouters: (state) => state.permission.addRouters,
  multiTab: (state) => state.app.multiTab,
  token: (state) => state.user.token,
  userInfo: (state) => state.user.userInfo,
};

export default getters;
